import { TAuthenticationModalType } from '../../../../../shared/common/types/authenticationModal';
import { ITypedReduxAction } from '../../../../../shared/common/types/redux/actionType';

export enum ERequestAuthenticationActionType {
  Modal = 'requestAuthentication/modal',
}

type TRequestAuthenticationModal = ITypedReduxAction<ERequestAuthenticationActionType.Modal, TAuthenticationModalType>;

export type TRequestAuthenticationReduxActions = TRequestAuthenticationModal;
